import LegalLayout from "@/pages/legal/LegalLayout";
import { SITE } from "@/data/site";

export default function Returns() {
  return (
    <LegalLayout
      testId="returns-page"
      eyebrow="Legal"
      title="Return Policy"
      subtitle="Your satisfaction is our priority. Here's how returns and refunds work at Medina Lia."
      updated="June 2026"
      sections={[
        {
          heading: "Our promise",
          body: [
            "We stand behind the quality of every bottle. If you're not completely satisfied with your purchase, we're here to help.",
          ],
        },
        {
          heading: "Return eligibility",
          body: ["To be eligible for a return, please note the following:"],
          list: [
            "Requests must be made within 30 days of delivery",
            "Unopened products in their original packaging qualify for a full refund",
            "For quality or safety reasons, opened consumable products may only be returned if defective or damaged",
          ],
        },
        {
          heading: "Damaged or incorrect items",
          body: [
            `If you receive a damaged, defective or incorrect item, please contact us within 7 days of delivery at ${SITE.email} with your order number and a photo. We'll arrange a replacement or refund right away.`,
          ],
        },
        {
          heading: "How to start a return",
          body: [
            `To begin a return, email us at ${SITE.email} or call ${SITE.phone}. Our team will guide you through the process and provide return instructions.`,
          ],
        },
        {
          heading: "Refunds",
          body: [
            "Once your return is received and inspected, we'll notify you of the approval status. Approved refunds are processed to your original payment method within 5–10 business days.",
          ],
        },
      ]}
    />
  );
}
